import React from 'react';

export default function ProductCard({ product }) {
  if (!product) return null;

  const { name, image, factory, sku, description } = product;

  return (
    <article className="product-card" aria-label={name}>
      <div className="product-media">
        <img
          src={image}
          alt={`${name} product image`}
          loading="lazy"
          onError={(e) => { e.currentTarget.src = '/images/products/placeholder.jpg'; }}
        />
        {factory && <span className="factory-badge">{factory}</span>}
      </div>

      <div className="product-body">
        <h3 className="product-title">{name}</h3>
        {sku && <p className="product-sku">SKU: {sku}</p>}
        {description && <p className="product-desc">{description}</p>}
      </div>
    </article>
  );
}